import { Card, Col, Row } from "reactstrap";
import CommonTourFooter from "../common/CommonTourFooter";
import CommonTourHeader from "../common/CommonTourHeader";
import CommonTourSocialMedia from "../common/CommonTourSocialMedia";
import SecondStyleAboutSection from "./SecondStyleAboutSection";

const UserProfileSecondStyle = () => {
  return (
    <Col sm="12">
      <Card>
        <div className="profile-img-style">
          <Row className="g-2">
            <CommonTourHeader date="25 Jan" time="6 min read" />
            <Col sm="4" className="mt-0 text-end">
              <CommonTourSocialMedia time="3 min ago" />
            </Col>
          </Row>
          <hr />
          <SecondStyleAboutSection />
          <CommonTourFooter />
        </div>
      </Card>
    </Col>
  );
};

export default UserProfileSecondStyle;
